/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import * as _ from 'lodash';

import { ActivatedRouteSnapshot } from '@angular/router';

import { ConfigService } from './../../core/services/config.service';
import { Injectable } from '@angular/core';
import { LmsEventDetails } from './../../core/model/lms-event-details.model';
import { LmsLoaderService } from '../../core/services/lms-loader.service';
import { Tab } from '../../core/model/tab.model';
import { TabService } from './../../core/services/tab.service';

/**
 * @export
 * @class AlertResolver
 * @implements {Resolve<Tab>}
 */
@Injectable()
export class AlertResolver  {
    constructor(
        private tabService: TabService,
        private configService: ConfigService,
        private lmsLoaderService: LmsLoaderService
    ) { }

    /**
     * Routing Resolver
     * @param {ActivatedRouteSnapshot} route
     * @returns
     * @memberOf AlertResolver
     */
    resolve(route: ActivatedRouteSnapshot) {
        let tab = this.tabService.getTabById(Math.abs(route.params['tabid']))[0];

        let tabType = this.configService.getConfigData().tab.event.update;
        if (!tab) {
            tabType = this.configService.getConfigData().tab.event.add;
            tab = { tabSearchParameter: { searchText: (route.queryParams['search'] ? route.queryParams['search'] : '') }, description: '' };
        }

        if (!(tab.subTypeDetail && tab.subTypeDetail.data && tab.subTypeDetail.data.status)) {
            if (!tab.subTypeDetail) {
                tab.subTypeDetail = {};
            }
            tab.subTypeDetail['data'] = {
                message: '',
                status: 'loaded'
            };
        }

        if (tab.tabSearchParameter && tab.tabSearchParameter.searchText) {
            if ((tabType === this.configService.getConfigData().tab.event.add) || (tab.subTypeDetail.data.status === 'blank')) {
                tab.subTypeDetail.data.status = 'refresh';
            }
        }

        tab.type = 'Alerts';
        tab.subType = 'Data';

        if ('error' === tab.subTypeDetail.data.status) {
            tab.description = tab.description;
        } else {
            tab.description = tab.tabSearchParameter.searchText ? `${tab.tabSearchParameter.searchText} - ${tab.subType}` : tab.description;
        }

        if (tabType === this.configService.getConfigData().tab.event.add) {
            tab.id = route.params['tabid'];
            if (tab.tabSearchParameter && !tab.tabSearchParameter.searchText) {
                this.lmsLoaderService.hideLoader();
            }
            return this.tabService.notifyChange(<LmsEventDetails>({
                type: tabType,
                data: tab
            }));
        } else {
            this.tabService.notifyChange(<LmsEventDetails>({
                type: tabType,
                data: tab
            }));
        }

        if (tab.tabSearchParameter && !tab.tabSearchParameter.searchText) {
            this.lmsLoaderService.hideLoader();
        }
        return this.tabService.getTabById(Math.abs(route.params['tabid']));

    }
}
